import type { PushPrefs, PushSubscriptionInfo } from "@codvero/shared";
import { api, del, get, post } from "./client.ts";

export const pushApi = {
  vapid: () => get<{ publicKey: string }>("/api/push/vapid"),
  list: () => get<PushSubscriptionInfo[]>("/api/push/subscriptions"),
  subscribe: (sub: PushSubscriptionJSON, label: string) => post<PushSubscriptionInfo>("/api/push/subscriptions", { endpoint: sub.endpoint, keys: sub.keys, label }),
  update: (id: string, input: { label?: string; prefs?: Partial<PushPrefs> }) => api<PushSubscriptionInfo>(`/api/push/subscriptions/${id}`, { method: "PATCH", json: input }),
  remove: (id: string) => del(`/api/push/subscriptions/${id}`),
  unsubscribeEndpoint: (endpoint: string) => post<void>("/api/push/unsubscribe", { endpoint }),
  test: (id?: string) => post<{ sent: number }>("/api/push/test", id ? { id } : {}),
};
